import React, { useEffect, useState } from 'react';
import { classNames } from 'primereact/utils';
import { Controller } from 'react-hook-form';
import { Chip } from 'primereact/chip';
import { pathOr } from 'ramda';

// api
import LookupdataService from '../../../../service/lookupdata-service';

// tools
import set404FromErrorResponse from '../../../../helpers/set404FromErrorResponse';

// components
import ChipWithIcon from '../../../ChipWithIcon';

const Chips = ({
    fieldName,
    label,
    control,
    errors,
    defaultValue = 0,
    config = {},
    infoText = null,
    disabled = false,
    lookupType = 'AIMED_TO',
    multiple = false
}) => {
    const [items, setItems] = useState([]);

    const getItemsCallback = (resp) => {
        const fetchedItems = pathOr([], ['data'], resp);
        setItems(fetchedItems);
    };

    const errGetItemsCallback = (resp) => {
        set404FromErrorResponse(resp);
    };

    useEffect(() => {
        LookupdataService.getItems(getItemsCallback, errGetItemsCallback, [
            ['type', lookupType]
        ]);
    }, [lookupType]);


    const input = <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={config}
        render={({ field, fieldState }) => (
            <div className="chipInner">
                {items.map(o => {
                    const isSelected = multiple
                        ? Array.isArray(field.value) && field.value.includes(o.id)
                        : o.id === field.value;
                    const handleClick = () => {
                        if (disabled) return;
                        if (multiple) {
                            const currentArr = Array.isArray(field.value) ? field.value : [];
                            const newValue = currentArr.includes(o.id)
                                ? currentArr.filter(v => v !== o.id)
                                : [...currentArr, o.id];
                            field.onChange(newValue);
                        } else {
                            field.onChange(o.id);
                        }
                    };
                    return (
                        <Chip
                            key={o.id}
                            className={classNames(
                                { 'chip--selected': isSelected },
                                { 'p-invalid': fieldState.invalid }
                            )}
                            label={o.value}
                            onClick={handleClick}
                            template={() => <ChipWithIcon value={o.value} />}
                        />
                    );
                })}
            </div>
        )}
    />;

    return (
        <>
            <label htmlFor={fieldName} className={classNames({ 'p-error': errors[fieldName] })}>
                {label}{config.required || config.isRequired ? <span className="appForm__field--required">*</span> : null}
            </label>
            {input}
            {infoText ? <small>{infoText}</small> : null}
        </>
    );
};

export default Chips;